module.exports = __webpack_public_path__ + "assets/img/face_search_scene2.8b52b1ea.png";